import React from 'react';
import { MapPin, Users } from 'lucide-react';

const StadionsPage = () => {
  const stadions = [
    { name: "MetLife Stadium", city: "New York/New Jersey", capacity: "82,500", country: "USA" },
    { name: "SoFi Stadium", city: "Los Angeles", capacity: "70,240", country: "USA" },
    { name: "AT&T Stadium", city: "Dallas", capacity: "80,000", country: "USA" },
    { name: "Estadio Azteca", city: "Mexico-Stad", capacity: "87,523", country: "Mexico" },
    { name: "BC Place", city: "Vancouver", capacity: "54,500", country: "Canada" },
    { name: "BMO Stadium", city: "Toronto", capacity: "30,000", country: "Canada" }
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Stadions</h1>
          <p className="text-xl opacity-90">16 stadions in 3 landen hosten het WK 2026</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Verenigde Staten (11 stadions)</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {stadions.filter(s => s.country === "USA").map((stadion, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md p-6">
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="font-bold text-lg mb-2">{stadion.name}</h3>
                    <div className="flex items-center text-gray-600">
                      <MapPin className="w-4 h-4 mr-2" />
                      {stadion.city}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="text-sm text-gray-500">Capaciteit</div>
                    <div className="font-bold text-amber-600">{stadion.capacity}</div>
                  </div>
                </div>
                <img src={`https://picsum.photos/seed/stadion${index}/400/200`} alt={stadion.name} className="w-full h-32 object-cover rounded-lg" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 bg-amber-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Mexico (3 stadions)</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {stadions.filter(s => s.country === "Mexico").map((stadion, index) => (
              <div key={index} className="bg-white rounded-xl shadow-md p-6">
                <h3 className="font-bold text-lg mb-2">{stadion.name}</h3>
                <div className="flex items-center text-gray-600 mb-2">
                  <MapPin className="w-4 h-4 mr-2" />
                  {stadion.city}
                </div>
                <div className="flex items-center text-gray-600">
                  <Users className="w-4 h-4 mr-2" />
                  {stadion.capacity}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default StadionsPage;